var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sort-link",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.sort}},[_vm._t("default"),_c('i',{staticClass:"fa",class:_vm.sortClass})],2)}
var staticRenderFns = []

export { render, staticRenderFns }